import { Dispatch, FC, SetStateAction } from 'react'
import { CwsButton, CwsDivider, CwsGridCol, CwsGridRow, CwsH3, CwsP } from '@components/cws'
import s from '@components/support/ContactUs/ContactUs.module.scss'
import { useTranslate } from '@hooks/useTranslation'
interface ContactUsCartProps {
  setVisibleModal: Dispatch<SetStateAction<boolean>>
}

export const ContactUsCart: FC<ContactUsCartProps> = ({ setVisibleModal }) => {
  const { translate } = useTranslate()
  return (
    <CwsGridRow noGutter>
      <CwsGridCol col="fluid">
        <div className={s.contactUs}>
          <CwsH3>{translate('account.contact.button')}</CwsH3>
          <CwsP>{translate('w2.contact.address')}</CwsP>
          <div className="flex gap-4">
            <div>
              <CwsP>{translate('w2.contact.company.name.title')}:</CwsP>
              <CwsP>{translate('w2.contact.company.name')}</CwsP>
            </div>
            <CwsDivider orientation="vertical" />
            <div>
              <CwsP>{translate('w2.contact.registration.no.title')}:</CwsP>
              <CwsP>{translate('w2.contact.registration.no')}</CwsP>
            </div>
          </div>
          <div className="flex flex-col">
            <CwsP>{translate('cart.confirmation.vendor.email.label')}:</CwsP>
            <CwsP>{translate('cart.confirmation.vendor.email.value')}</CwsP>
          </div>
          <CwsButton data-modal-id="feedback-modal" onClick={() => setVisibleModal(true)} width="fluid">
            {translate('w2.contact.button')}
          </CwsButton>
        </div>
      </CwsGridCol>
    </CwsGridRow>
  )
}
